import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { CommonSearch } from '../Classes/CommonClass';


@Injectable()
export class CommonService {
  ApiRootPath: string = "api/Common/";
  constructor(private http: Http) { }

  GetEntitySearchResult(_CommonSearch: CommonSearch) {
    let body: string = JSON.stringify(_CommonSearch);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post(this.ApiRootPath +'GetEntitySearchResult', body, options)
      .map((res: Response) => res.json());
  }

  GetAutoCompleteResult(_CommonSearch: CommonSearch) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let ParmDetails = { "Searchstring": JSON.stringify(_CommonSearch.Searchstring), "SearchType": JSON.stringify(_CommonSearch.SearchType) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
    return this.http.get(this.ApiRootPath + 'GetAutoCompleteResult', options)
      .map((res: Response) => res.json());
  }

  


 
}



// WEBPACK FOOTER //
// ./src/app/Services/CommonServices.ts